"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _icon = _interopRequireDefault(require("../icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var SvgCloseCircleFill = function SvgCloseCircleFill(props, svgRef) {
  return /*#__PURE__*/React.createElement(_icon["default"], _objectSpread(_objectSpread({}, props), {}, {
    component: function component() {
      return /*#__PURE__*/React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 1000 1000",
        fill: "currentColor",
        focusable: false,
        "aria-hidden": "true",
        ref: svgRef
      }, /*#__PURE__*/React.createElement("path", {
        d: "M500 0C224.32 0 0 224.286 0 500s224.286 500 500 500c275.68 0 500-224.286 500-500S775.714 0 500 0zm203.965 654c13.928 14 13.892 36.572-.072 50.5a35.644 35.644 0 01-25.213 10.429c-9.179 0-18.321-3.5-25.287-10.5L499.821 550.393l-154.07 152.43c-6.964 6.857-16.037 10.32-25.109 10.32-9.213 0-18.392-3.536-25.392-10.607-13.857-14.036-13.75-36.608.286-50.5L449.43 499.821 296.107 346c-13.93-13.965-13.893-36.572.07-50.5 13.966-13.965 36.536-13.892 50.5.07l153.536 154 154.071-152.427c14-13.892 36.643-13.75 50.5.286 13.892 14.036 13.75 36.643-.286 50.5l-153.89 152.213L703.965 654z",
        fillRule: "nonzero"
      }));
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleFill);
var _default = ForwardRef;
exports["default"] = _default;